export const languageToCountries: Record<string, string[]> = {
    en: ['US', 'GB', 'AU', 'CA', 'NZ', 'IE'],
    vi: ['VN'],
    fr: ['FR', 'BE', 'CH', 'CA', 'LU'],
    es: ['ES', 'MX', 'AR', 'CO', 'CL', 'PE', 'VE'],
    pt: ['PT', 'BR'],
    zh: ['CN', 'HK', 'SG', 'TW'],
    ar: ['AE', 'SA', 'EG', 'IQ', 'JO', 'KW', 'MA'],
    de: ['DE', 'AT', 'CH'],
    ru: ['RU', 'BY', 'KZ'],
    ja: ['JP'],
    ko: ['KR'],
    th: ['TH'],
    hi: ['IN'],
};

export function getLanguageByCountryCode(countryCode: string): string | null {
    const upperCode = countryCode.toUpperCase();
    for (const [lang, countries] of Object.entries(languageToCountries)) {
        if (countries.includes(upperCode)) return lang;
    }
    return null;
}
